import { SINGER_TYPES } from '@/configs/participants';

export function isDocumentSigned(document) {
	if (!document || !document.signs || !document.signs.length) return false;
	return document.signs.every(sign => !!sign.type);
}

export function isDocumentSignedByThirdParty(document) {
	return document.legalDoc && document.signs.some(sign => sign.signerType !== SINGER_TYPES.PARTICIPANT);
}

export function getDocumentSignedAt(document) {
	const sign = document?.signs.find(sign => sign.acceptedAt || sign.signedAt);
	return sign?.acceptedAt || sign?.signedAt;
}

export function isDocumentSignedByParticipant(document, participantId) {
	if (!document || !Array.isArray(document.signs) || document.signs.length === 0) {
		return false;
	}

	return document.signs.some((sign) => {
		return String(sign.signerType) === SINGER_TYPES.PARTICIPANT
			&& String(sign.signerId) === String(participantId)
			&& Boolean(sign.type);
	});
}